import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    [theme.breakpoints.up('lg')]: {
      alignItems: 'flex-start',
    },
  },
  emailLoginWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    margin: '0 auto',
  },
  // Kept above the 55px top padding of the form content so it never covers the
  // centred logo on narrow screens.
  localeSwitcher: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 1,
    [theme.breakpoints.up('lg')]: {
      top: theme.spacing(3),
      right: theme.spacing(3),
    },
  },
  emailLoginFormContent: {
    height: '100%',
    padding: '55px 24px 0 24px',
    width: '100%',
    maxWidth: '500px',
    '& .MuiInputBase-root': {
      paddingRight: '0',
    },
    '& .MuiInputBase-input': {
      background: theme.palette.common.white,
    },
    '& .MuiInputLabel-root': {
      fontSize: '0.95rem',
    },
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  emailLoginRightCol: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('lg')]: {
      height: '100%',
      width: '50%',
    },
  },
  emailLoginLeftCol: {
    width: '50%',
    height: '100%',
    display: 'none',
    justifyContent: 'flex-end',
    [theme.breakpoints.up('lg')]: {
      display: 'flex',
      alignItems: 'flex-end',
      '&> .MuiBox-root': {
        width: '100%',
        paddingBottom: '15px',
        fontSize: '0.875rem',
        color: theme.palette.grey[200],
        '& a': {
          color: theme.palette.grey[200],
          textDecoration: 'none',
          borderLeft: `1px solid ${theme.palette.border}`,
          paddingLeft: '10px',
          marginLeft: '4px',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
  },
  companyLogo: {
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
    '@media (max-height: 468px)': {
      display: 'none',
    },
  },
  loginText: {
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  loginDisclaimerMessageText: {
    paddingTop: '16px',
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
    '& > a': {
      color: theme.palette.label.light,
      textDecoration: 'none',
    },
  },
  formSubmitRow: {
    textAlign: 'center',
    padding: '16px 0',
    '& button': {
      width: '100%',
    },
  },
  helpTextDiv: {
    padding: '8px 0 0',
    '& > span': {
      paddingRight: '10px',
      '& > p': {
        display: 'inline',
      },
    },
    '& > a': {
      color: theme.palette.label.light,
      textDecoration: 'none',
      '& > p': {
        display: 'inline',
      },
    },
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  useSsoDiv: {
    padding: '0 0 8px',
    '& > span': {
      paddingRight: '10px',
    },
    '& > a': {
      color: theme.palette.label.light,
      textDecoration: 'none',
    },
    [theme.breakpoints.down('lg')]: {
      textAlign: 'center',
    },
  },
  formErrorSvg: {
    verticalAlign: 'text-bottom',
    'rect, path': {
      stroke: theme.palette.error.main,
    },
  },
  continueButtonValidating: {
    '&.Mui-disabled': {
      backgroundColor: theme.new.color.actionHover,
    },
  },
  loaderIcon: {
    color: theme.palette.brand[300],
  },
}));

export default useStyles;
